import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="display-toggler"
export default class extends Controller {
  static targets = ["toggled"];

  toggledTargetConnected() {
    this.hide();
  }

  toggle() {
    this.#isShown() ? this.hide() : this.show();
  }

  show() {
    this.toggledTarget.style.display = "block";
    this.dispatch("show");
  }

  hide() {
    this.toggledTarget.style.display = "none";
  }

  hideOthers(event) {
    if (event.target !== this.element) {
      this.hide();
    }
  }

  #isShown() {
    return $(this.toggledTarget).is(":visible");
  }
}
